module.exports = __webpack_public_path__ + "img/stage_default.4a3bea87.jpg";